<!-- eslint-disable -->
<template>
    <vue-monthly-picker :monthLabels="months"
                        :dateFormat="dateFormat"
                        @input="monthSelected"
                        :value="value"
    ></vue-monthly-picker>
</template>

<script>
    /*eslint-disable*/
    import moment from "moment";
    import VueMonthlyPicker from 'vue-monthly-picker'
    import _ from 'lodash'

    export default {
        props: ['value'],
        components: {
            VueMonthlyPicker
        },
        data () {
            return {
                months: [
                    this.$i18n.t('timeMeasurement.timeMeasurement_monthPicker_jan'),
                    this.$i18n.t('timeMeasurement.timeMeasurement_monthPicker_feb'),
                    this.$i18n.t('timeMeasurement.timeMeasurement_monthPicker_mar'),
                    this.$i18n.t('timeMeasurement.timeMeasurement_monthPicker_apr'),
                    this.$i18n.t('timeMeasurement.timeMeasurement_monthPicker_may'),
                    this.$i18n.t('timeMeasurement.timeMeasurement_monthPicker_jun'),
                    this.$i18n.t('timeMeasurement.timeMeasurement_monthPicker_jul'),
                    this.$i18n.t('timeMeasurement.timeMeasurement_monthPicker_aug'),
                    this.$i18n.t('timeMeasurement.timeMeasurement_monthPicker_sep'),
                    this.$i18n.t('timeMeasurement.timeMeasurement_monthPicker_oct'),
                    this.$i18n.t('timeMeasurement.timeMeasurement_monthPicker_nov'),
                    this.$i18n.t('timeMeasurement.timeMeasurement_monthPicker_dec')
                ],
                oldMonth: undefined
            };
        },
        watch: {
            value: {
                handler (value) {
                    moment.locale(this.$i18n.locale);
                    let month = _.capitalize(moment(value).format('MMMM'));
                    if (month === this.oldMonth) {
                        return
                    }
                    let allElems = document.querySelector('.vue-monthly-picker .date-popover .picker .monthItem').children
                    allElems[this.months.indexOf(month)].classList.add('disabled')
                    this.oldMonth !== undefined && allElems[this.months.indexOf(this.oldMonth)].classList.remove('disabled')
                    this.oldMonth = month
                }
            }
        },
        methods: {
            monthSelected (month) {
                this.$emit('input', moment(month._d).format('YYYY-MM-DD'));
            }
        },
        computed: {
            dateFormat () {
                return `[${_.capitalize(moment(this.value).locale(this.$i18n.locale).format('MMMM'))}] YYYY`
            }
        }
    }
</script>